import { all } from 'redux-saga/effects';
import companySagas from './company';
import groupSagas from './groups';
import programSagas from './programs';
import employeeSagas from './employees';
import twoFactorSagas from './twoFactor';
import watchSagas from './watchSagas';
import paymentSagas from './payments';
import questionsSagas from './questions';
import reportsSagas from './reports';

export default function* rootSaga() {
  yield all([
    watchSagas(),
    companySagas(),
    groupSagas(),
    programSagas(),
    employeeSagas(),
    twoFactorSagas(),
    paymentSagas(),
    questionsSagas(),
    reportsSagas(),
  ]);
}
